import * as layout from '../../components/markLayout.module.css';
import Table, { TableColumn } from '@hero/ui-kit/tables/Table';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import H from '@hero/ui-kit/typography/H';
import Tag from '@hero/ui-kit/components/Tag';
import { formatDateTime, normalizeDateString } from '@hero/hero-utils/date';
import type { SuppressionHistoryEntry } from '../../types';
type Props = {
    history: SuppressionHistoryEntry[];
};
const columns: TableColumn<
    SuppressionHistoryEntry & {
        row_id: number;
    }
>[] = [
    {
        colKey: 'action',
        name: 'Action',
        align: 'left',
        headAlign: 'left',
        render: (entry) => (
            <Tag type={entry.action === 'SUPPRESS' ? 'fail' : 'success'} size="small">
                {entry.action}
            </Tag>
        )
    },
    {
        colKey: 'reason',
        name: 'Reason',
        align: 'left',
        headAlign: 'left',
        render: (entry) => <P noDefaultMargin>{entry.reason || '—'}</P>
    },
    {
        colKey: 'actor',
        name: 'Actor',
        align: 'left',
        headAlign: 'left',
        render: (entry) => <P noDefaultMargin>{entry.actor_user_id ?? '—'}</P>
    },
    {
        colKey: 'note',
        name: 'Note',
        align: 'left',
        headAlign: 'left',
        render: (entry) => <P noDefaultMargin>{entry.note || '—'}</P>
    },
    {
        colKey: 'date',
        name: 'Date',
        align: 'left',
        headAlign: 'left',
        render: (entry) => (
            <P noDefaultMargin>{formatDateTime(normalizeDateString(entry.created))}</P>
        )
    }
];
const SuppressionHistoryList: React.FC<Props> = ({ history }) => {
    if (history.length === 0) {
        return null;
    }
    return (
        <div
            style={{
                marginTop: '2.4rem'
            }}
        >
            <H
                role="h6"
                noDefaultMargin
                styles={{
                    marginBottom: '1.2rem'
                }}
            >
                Suppression History
            </H>
            <div
                style={{
                    overflowX: 'auto'
                }}
                className={layout.tableScroll}
            >
                <Table
                    columns={columns}
                    data={history.map((entry, row_id) => ({ ...entry, row_id }))}
                    rowKey="row_id"
                    emptyValues="—"
                />
            </div>
        </div>
    );
};
export default SuppressionHistoryList;
